import { render, staticRenderFns } from "./MediationSterlingPayment.vue?vue&type=template&id=4de3d1fe&"
import script from "./MediationSterlingPayment.vue?vue&type=script&lang=js&"
export * from "./MediationSterlingPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports